__turbopack_context__.v({
  "btn": "FooterBanner-module-scss-module__MqsyTq__btn",
  "imgWrapper": "FooterBanner-module-scss-module__MqsyTq__imgWrapper",
  "item": "FooterBanner-module-scss-module__MqsyTq__item",
  "itemText": "FooterBanner-module-scss-module__MqsyTq__itemText",
  "list": "FooterBanner-module-scss-module__MqsyTq__list",
  "listWrapper": "FooterBanner-module-scss-module__MqsyTq__listWrapper",
  "main": "FooterBanner-module-scss-module__MqsyTq__main",
  "title": "FooterBanner-module-scss-module__MqsyTq__title",
  "wrapper": "FooterBanner-module-scss-module__MqsyTq__wrapper",
});
